import { render, staticRenderFns } from "./fade.vue?vue&type=template&id=b8af0f32&scoped=true"
import script from "./fade.vue?vue&type=script&lang=js"
export * from "./fade.vue?vue&type=script&lang=js"
import style0 from "./fade.vue?vue&type=style&index=0&id=b8af0f32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8af0f32",
  null
  
)

export default component.exports